import { Input, Select, Switch } from '@ethsign/ui';
import { useEffect, useState } from 'react';

import { IField } from '@/types';
type Props = {
  open: boolean;
  onValueChange: (value: any) => void;
  showInputType?: boolean;
  value?: IField;
};
const typeToText = {
  text: 'Text',
  term: 'Term',
  date: 'Date',
  signature: 'Signature'
};

const inputTypes = [
  { label: 'Text', value: 'text' },
  { label: 'Number', value: 'number' },
  { label: 'Date', value: 'date' },
  { label: 'Textarea', value: 'textarea' }
];
export const FieldSettingsDrawer = (props: Props) => {
  const { open, onValueChange, value, showInputType } = props;
  const [label, setLabel] = useState<any>(value?.label);
  const [required, setRequired] = useState<any>(!!value?.required);
  const [inputType, setInputType] = useState<any>(value?.inputType);
  useEffect(() => {
    onValueChange({ label, required, inputType });
  }, [label, required, inputType]);
  useEffect(() => {
    setLabel(value?.label);
    setRequired(!!value?.required);
    setInputType(value?.inputType);
  }, [value?.label, !!value?.required, value?.inputType]);

  return (
    <div
      className={`z-50 transition-all translate-x-[100%] absolute px-6 pt-8 w-[320px] top-0 bottom-0 right-0 h-auto shadow-none border-l border-gray-200 bg-white ${
        open ? '!translate-x-0' : ''
      }`}
    >
      {open && (
        <div>
          <div className="text-lg font-bold text-gray-600">Settings</div>
          <div className="mt-6 text-xs font-normal text-gray-400">
            {typeToText[value?.type as keyof typeof typeToText]} Properties
          </div>

          {(value?.type === 'text' || value?.type === 'term' || !value?.type) && (
            <>
              <div className="text-sm font-medium text-gray-600 mt-4 mb-[6px]">Field Label</div>
              <Input
                key={value?.id}
                defaultValue={value?.label}
                value={label}
                placeholder="Enter label here"
                onChange={(e) => {
                  setLabel(e.target.value);
                }}
              ></Input>
            </>
          )}
          <div className="mt-4 flex flex-row justify-between items-center">
            <span className="text-sm font-medium text-gray-600 ">Required</span>{' '}
            <Switch
              key={value?.id}
              checked={required}
              defaultChecked={value?.required}
              onCheckedChange={setRequired}
            ></Switch>
          </div>
          {!!showInputType && (
            <div className="mt-4 flex flex-row justify-between items-center">
              <span className="text-sm font-medium text-gray-600 ">Input Type</span>{' '}
              <Select value={inputType} options={inputTypes} onChange={setInputType}></Select>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
